const state = window.teal_state = window.teal_state || {};
state.range_group = state.range_group || {};


// load.all(() => {
// 	window.updateRangeUI();
// });


/**
 * Update range slider UI and summary
 * @param {element} $wrapper
 * @param {boolean} trigger_change
 */
window.updateRangeUI = function($wrapper, trigger_change = false) {
	if (!$wrapper) {
		const $wrappers = document.querySelectorAll('.range-group');
		$wrappers.forEach($wrapper => {
			window.updateRangeUI($wrapper, trigger_change);
		});
		return false;
	}
	
	const $slider = $wrapper.querySelector('.range-group__inner');
	const $input_min = $slider.querySelector('.range-group__field--min');
	const $input_max = $slider.querySelector('.range-group__field--max');
	const $bubble_min = $slider.querySelector('.range-group__value-bubble--min');
	const $bubble_max = $slider.querySelector('.range-group__value-bubble--max');
	const $track = $slider.querySelector('.range-group__track');
	const $fill = $slider.querySelector('.range-group__track__fill');
	const $thumb_min = $slider.querySelector('.range-group__track__thumb--min');
	const $thumb_max = $slider.querySelector('.range-group__track__thumb--max');
	
	const min = +$input_min.min;
	const max = +$input_max.max;
	
	const val_min = Math.min(+$input_min.value, +$input_max.value);
	const val_max = Math.max(+$input_min.value, +$input_max.value);
	
	const percent_min = (val_min - min) / (max - min);
	const percent_max = (val_max - min) / (max - min);
	
	const track_width = $track.offsetWidth;
	const px_min = percent_min * track_width;
	const px_max = percent_max * track_width;
	
	$thumb_min.style.left = `${px_min}px`;
	$thumb_max.style.left = `${px_max}px`;
	$fill.style.left = `${px_min}px`;
	$fill.style.width = `${px_max - px_min}px`;
	$bubble_min.style.left = `${px_min}px`;
	$bubble_max.style.left = `${px_max}px`;
	$bubble_min.textContent = val_min;
	$bubble_max.textContent = val_max;
	
	const collision_c = 'range-group__value-bubble--flip';
	const is_collision = (px_max - px_min < 40);
	if (is_collision) {
		$bubble_max.classList.add(collision_c);
	} else {
		$bubble_max.classList.remove(collision_c);
	}
	
	// Calculate summary text
	const wrapper_min = +$wrapper.getAttribute('data-min');
	const wrapper_max = +$wrapper.getAttribute('data-max');
	const is_default = (val_min === wrapper_min) && (val_max === wrapper_max);
	const all_summary = $wrapper.getAttribute('data-summary-all') || 'All';
	const summary_text = is_default ? all_summary : `${val_min} - ${val_max}`;
	
	// Store summary in data attribute for parent (expandable-field-group) to read
	$wrapper.setAttribute('data-summary-current', summary_text);
	
	if (trigger_change) {
		$input_min.dispatchEvent(new Event('input', { bubbles: true }));
		$input_max.dispatchEvent(new Event('input', { bubbles: true }));
		$input_min.dispatchEvent(new Event('change', { bubbles: true }));
		$input_max.dispatchEvent(new Event('change', { bubbles: true }));
	}
}


document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.range-group').forEach($wrapper => {
		const $slider = $wrapper.querySelector('.range-group__inner');
		const $input_min = $slider.querySelector('.range-group__field--min');
		const $input_max = $slider.querySelector('.range-group__field--max');
		// const $bubble_min = $slider.querySelector('.range-group__value-bubble--min');
		// const $bubble_max = $slider.querySelector('.range-group__value-bubble--max');
		const $track = $slider.querySelector('.range-group__track');
		// const $fill = $slider.querySelector('.range-group__track__fill');
		const $thumb_min = $slider.querySelector('.range-group__track__thumb--min');
		const $thumb_max = $slider.querySelector('.range-group__track__thumb--max');
		
		const min = +$input_min.min;
		const max = +$input_max.max;
		
		function update(trigger_change = false) {
			window.updateRangeUI($wrapper, trigger_change);
		}
		
		function attach_drag($thumb, $input, is_min_thumb) {
			let last_value = null;
			
			const get_x = (e) => {
				return e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX;
			};
			
			const on_move = (e) => {
				const rect = $track.getBoundingClientRect();
				let x = get_x(e) - rect.left;
				x = Math.max(0, Math.min(x, rect.width));
				
				const percent = x / rect.width;
				const value = Math.round(min + percent * (max - min));
				if (value === last_value) return;
				
				last_value = value;
				
				if (is_min_thumb && value >= +$input_max.value) return;
				if (!is_min_thumb && value <= +$input_min.value) return;
				
				if (is_min_thumb) {
					$input_min.value = value;
				} else {
					$input_max.value = value;
				}
				update(false);
			};
			
			const on_up = () => {
				if (last_value !== null) {
					if (is_min_thumb) {
						$input_min.value = last_value;
					} else {
						$input_max.value = last_value;
					}
					update(true);
				}
				
				// Remove the global flag after a short delay to prevent the click event
				// from closing any parent expandable
				setTimeout(() => {
					state.range_group.is_dragging = false;
				}, 10);
				
				document.removeEventListener('mousemove', on_move);
				document.removeEventListener('mouseup', on_up);
				document.removeEventListener('touchmove', on_move);
				document.removeEventListener('touchend', on_up);
			};
			
			const on_start = (e) => {
				e.preventDefault();
				last_value = null;
				
				// Mark that drag has started
				state.range_group.is_dragging = true;
				
				document.addEventListener('mousemove', on_move);
				document.addEventListener('mouseup', on_up);
				document.addEventListener('touchmove', on_move, { passive: false });
				document.addEventListener('touchend', on_up);
			};
			
			$thumb.addEventListener('mousedown', on_start);
			$thumb.addEventListener('touchstart', on_start, { passive: false });
		}
		
		attach_drag($thumb_min, $input_min, true);
		attach_drag($thumb_max, $input_max, false);
		
		// Sync UI on input change
		$input_min.addEventListener('input', () => update(false));
		$input_max.addEventListener('input', () => update(false));
		
		// Initial layout and value sync
		requestAnimationFrame(() => {
			setTimeout(() => {
				if (+$input_min.value < min || +$input_min.value > max) {
					$input_min.value = min;
				}
				if (+$input_max.value > max || +$input_max.value < min) {
					$input_max.value = max;
				}
				update(false);
				$wrapper.setAttribute('data-range-initialized', '');
			}, 50);
		});
	});
});


/**
 * Handle window resize to recalculate slider layout
 * Uses debouncing to avoid excessive updates during resize
 */
let resize_timeout = null;
window.addEventListener('resize', () => {
	clearTimeout(resize_timeout);
	resize_timeout = setTimeout(() => {
		document.querySelectorAll('.range-group[data-range-initialized]').forEach($wrapper => {
			window.updateRangeUI($wrapper, false);
		});
	}, 100);
});
